export class CampoDettaglioTransazione {
  titolo: string;
  valore: string;
  campoServizioId: number;
  tipoCampo: string;
}
